import { FC } from 'react';
import cn from 'classnames';
import { Modal, ModalProps } from './modal';
import './presentModal.styl';
import { useTranslationsContext } from 'store/translations';
import { useStoreContext } from 'store/app';
import { ISnake } from 'src/types';

interface PresentModalProps extends Omit<ModalProps, 'children'> {
    collectionName: string;
    snake: ISnake;
    count: number;
}

const getPrimaryButtonText = (count: number): string => {
    switch (count) {
        case 0:
        case 1:
            return 'present.modal.button.not.enough';

        default:
            return 'present.modal.button.exchange';
    }
};

export const PresentModal: FC<PresentModalProps> = ({
    collectionName,
    snake,
    count,
    onClickPrimaryBtn,
    onClose,
    ...rest
}) => {
    const { translate } = useTranslationsContext();
    const { isCollectionFinished, isMainPartFinished } = useStoreContext();

    const handleClickPrimaryBtn = () => {
        onClickPrimaryBtn?.();
        onClose();
    };

    const {
        name,
        custom_params: { bg, shadow, title, img }
    } = snake;

    return (
        <Modal
            description={
                count === 0
                    ? translate('present.modal.subtitle.zero')
                    : count === 1 || isCollectionFinished || isMainPartFinished
                    ? undefined
                    : translate('present.modal.subtitle')
            }
            primaryButtonText={translate(getPrimaryButtonText(count))}
            primaryButtonDisabled={count <= 1 || isCollectionFinished || isMainPartFinished}
            onClickPrimaryBtn={handleClickPrimaryBtn}
            onClose={onClose}
            title={translate('present.modal.title', {}, 'Игрушка')}
            className={cn('present-mob', count <= 1 && 'hidden-btn')}
            {...rest}
        >
            <div className="modal-present" style={{ background: bg, boxShadow: shadow }}>
                <div className="modal-present-img">
                    <img className="modal-present-img-orig" src={img} alt="present" />
                </div>
                <div className="modal-present-info">
                    <span className="modal-present-collection-name">{collectionName}</span>
                    <span className="modal-present-name">{title || name}</span>
                    <span className="modal-present-count">{translate('snake.amount', { count })}</span>
                </div>
            </div>
        </Modal>
    );
};
